<template>
    <div>
        <figure class="tourFigure">
            <div v-if="!showInfo">
                <img :src="currentRouteImages">
                <div style="margin-top: 40px" class="upload-icon visible-upload-icon" v-if="!currentRoute.route_image&&!currentRoute.avatar">
                    <md-button aria-label="Upload Image">
                        <form id="tourImage" enctype="multipart/form-data" novalidate class="upload-btn btn-for-upload">
                            <input class="file-input" accept="image/*" type="file" id="files" ref="files" v-on:change="handleFileUpload($event)"/>
                            <md-icon class="photo-icon">photo_size_select_actual</md-icon>
                        </form>
                        <p class="upload-text" v-if="!fileflag">Click to upload a route image</p>
                        <p class="upload-text" v-else>File selected click here to change file</p>
                    </md-button>
                </div>
                <div class="gradient-box"></div>
                <div class="line-item">
                    <div class="left-item" style="    position: fixed;">
                        <md-button title="Back to Routes" class="md-icon-button" @click="returnToPrevious" aria-label="Back">
                            <md-icon>arrow_back</md-icon>
                        </md-button>
                    </div>
                    <div class="left-item" style="position: fixed;margin-left: 3%;">
                        <h3 class="link" @click="toggleInfoBlock('EDITOPEN')">{{ currentRoute.name }}</h3>
                    </div>
                    <div class="right-item">
                        <md-menu>
                            <md-button md-menu-trigger class="md-icon-button">
                                <md-icon>more_vert</md-icon>
                            </md-button>
                            <md-menu-content width="3">
                                <md-menu-item>
                                    <button class="md-button" @click="exportCurrentTour(currentTour.id)">Export Tour</button>
                                </md-menu-item>
                                <md-menu-item>
                                    <button class="md-button" @click="toggleShowSettings(true), callRouteSettingFunction(1)">Route Settings</button>
                                </md-menu-item>
                                <md-menu-item v-if="currentRoute.route_image || currentRoute.avatar">
                                    <div class="upload-btn">
                                        <form id="tourImage" enctype="multipart/form-data">
                                            <label style="width: 192px;" for="files" class="md-button"> Change Route Image </label>
                                            <input class="file-input" accept="image/*" type="file" id="files" ref="files" v-on:change="handleFileUpload($event)"/>
                                        </form>
                                    </div>
                                </md-menu-item>
                            </md-menu-content>
                        </md-menu>
                    </div>
                </div>
            </div>
            <div class="info-block" v-if="showInfo">
                <h3>
                    <textarea maxlength="60" rows="1" v-model="currentRoute.name" placeholder="Route Name"></textarea>
                </h3>
                <p>
                    <textarea maxlength="200" v-model="currentRoute.description" placeholder="Description"></textarea>
                </p>
                <md-button class="md-icon-button close-info" @click="toggleInfoBlock('EDITCLOSE')">
                    <md-icon>close</md-icon>
                </md-button>
                <md-button class="save-button md-raised md-primary" @click="saveRouteDetails">Save</md-button>
            </div>
        </figure>
        <md-dialog :md-active.sync="checkTarballComplet" style="overflow-y: scroll;">
            <md-list class="full-control">
                <p>
                    Your tour is still incomplete to make tarball. So complete your tour and export tarball.
                </p>
                <md-button class="ManualBtn ManualBtncancel" @click="closeCheckTarballComplet()">Close</md-button>
            </md-list>
        </md-dialog>
    </div>
</template>
<script>
import {updateRouteDetails, checkExportTours, uploadRouteFile} from '../../services/EditorService.js';
import {mapGetters, mapActions} from 'vuex';

export default {
  data: () => ({
    showInfo: false,
    checkTarballComplet: false,
    file: '',
    currentRouteImages: '',
    editTourName: '',
    editTourDes: ''
  }),
  computed: {
    ...mapGetters('routes', ['currentRoute']),
    ...mapGetters('client', ['currentClient']),
    ...mapGetters('tours', ['currentTour'])
  },
  methods: {
    ...mapActions('editor', ['toggleShowSettings']),
    ...mapActions('tours', ['exportTours']),
    getImageSrc (image) {
      return 'static/img/' + image;
    },
    callRouteSettingFunction (param) {
      this.clearCurrentRoute();
      this.$bus.$emit('changevariableValueOfRouteSetting');
    },
    toggleInfoBlock (editOpenClose) {
      if (editOpenClose === 'EDITOPEN') {
        this.editTourName = this.currentRoute.name;
        this.editTourDes = this.currentRoute.description;
      }
      if (editOpenClose === 'EDITCLOSE') {
        this.currentRoute.name = this.editTourName;
        this.currentRoute.description = this.editTourDes;
      }
      this.showInfo = !this.showInfo;
    },
    returnToPrevious () {
      this.$router.push('/tour/topicRoutes/routes');
    },
    saveRouteDetails () {
      if (this.currentRoute.name.length >= 1 && this.currentRoute.description.length >= 1) {
        var route = this.currentRoute;
        route.clientId = this.currentClient.id;
        route.systemId = 1; // temporary until we get sysId figured route
        updateRouteDetails(route);
        this.toggleInfoBlock('SAVECLOSE');
      }
    },
    closeCheckTarballComplet () {
      this.checkTarballComplet = false;
    },
    exportCurrentTour (tourId) {
      let self = this;
      checkExportTours(tourId).then(function (defs) {
        if (defs.data[0].activeInactiveImages === 0) {
          self.checkTarballComplet = true;
        } else {
          self.exportTours({tourIds: [tourId], clientId: self.currentClient.id});
        }
      });
    },
    handleFileUpload (event) {
      this.file = event.target.files[0];
      var routeId = this.currentRoute.id;
      this.currentRouteImages = URL.createObjectURL(event.target.files[0]);
      this.currentRoute.route_image = URL.createObjectURL(event.target.files[0]);
      uploadRouteFile(event.target.files[0], routeId);
    }
  },
  mounted () {
    if (!this.currentRoute.route_image) {
      this.currentRouteImages = 'static/img/' + this.currentRoute.avatar;
    } else {
      this.currentRouteImages = this.currentRoute.route_image;
    }
  }
};
</script>
<style lang="scss">
.info-block .save-button {
    bottom: 10px;
}
</style>
<style lang="scss">
.newTourFigure .newTourlogo {
    margin-top: 30px !important;
    min-height: 110px !important;
    margin-bottom: 0px;
}

.upload-btn .file-input {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 25%;
    left: 30%;
    opacity: 0 !important;
}

.map-page .upload-btn.btn-for-upload {
    position: relative !important;
    top: auto !important;
    right: auto !important;
}

.upload-text {
    position: static !important;
    top: auto !important;
}

.photo-icon {
    display: block !important;
}
.map-page aside figure .info-block h3 textarea{
  height: 43px;
  width: calc(100% - 30px);
  overflow: auto;
  line-height: 22px;
}
.map-page aside figure .info-block p textarea{
  height: 70px !important;
  width: calc(100% - 30px);
  overflow: auto;
}
.map-page aside figure .line-item{
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/tour/RouteFigure.vue